import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { debounce } from "lodash";
import { toast } from "react-toastify";
import { Button, Grid, Typography } from "@mui/material";
import {
  getAutoComplete,
  getGeocode,
  getNearBySearch,
  getPlaceDetails,
} from "redux/actions/UserGoogleMap"; //action, reducer, saga, service file, actionTypes
import { getTrip } from "redux/actions/UserTrip"; //action, saga, reducer, actionTypes, service file
import { getRentalSlab, getTripSlab } from "redux/actions/UserCustomerTrip"; //action, saga, reducer, actionTypes
// import Footer from "./Footer";
import DashboardPages from "./DashboardPages"; //done
import CommonRideTab from "./CommonRideTab"; //done
import HomeRideInfo from "./HomeRideInfo"; //done
import {
  airportData,
  oneWayData,
  outStationData,
  rentalData,
} from "./RideTypeData"; //done
import { toastObject, tripEnumObject } from "utils/enumObject"; //done
import UserDetails from "./userDetails/UserDetails";

function CommonRideView(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [value, setValue] = useState(type ? type : tripEnumObject?.oneWay);
  const [currentLat, setCurrentLat] = useState("");
  const [currentLong, setCurrentLong] = useState("");
  const [rentalPackage, setRentalPackage] = useState("");
  const [needPlacard, setNeedPlacard] = useState(false);
  const [placardText, setPlacardText] = useState('');

  const token = localStorage.getItem("token");
  const sessionDate = sessionStorage.getItem("date");
  const sessionEndDate = sessionStorage.getItem("endDate");
  const [pickup, setPickup] = useState({});
  const pickupLoc = sessionStorage.getItem("pickup");
  const drop = sessionStorage.getItem("drop");
  const [date, setDate] = useState(sessionDate ? dayjs(sessionDate) : null);
  const [endDate, setEndDate] = useState(
    sessionEndDate && dayjs(sessionEndDate)
  );
  const [defaultValues, setDefaultValues] = useState({
    pickup: pickup,
    drop: drop,
    date: date,
    endDate: endDate,
  });
  const locationData =
    useSelector(
      (state) => state.userAutoComplete?.userAutoComplete?.data?.predictions
    ) || [];
  const placeDetailsData =
    useSelector(
      (state) =>
        state.userPlaceDetails?.pickup?.pickup?.data?.result?.geometry?.location
    ) || [];
  const currentLocationData =
    useSelector((state) => state.userGeocode?.userGeocode?.results) || [];
  const nearbySearchData =
    useSelector(
      (state) => state.userNearBySearch?.userNearBySearch?.data?.results
    ) || [];

  const locationLoader = useSelector((state) => state.userGeocode?.loading);
  const [currentLoader, setCurrentLoader] = useState(locationLoader || false);
  const rentalSlabLocation =
    useSelector((state) => state.userRentalSlab?.userRentalSlab?.data?.body) ||
    [];
  const bufferTime = useSelector(
    (state) => state.userRentalSlab?.userRentalSlab?.data?.bookingBuffer
  );
  const rentalSlabCurrentLocation =
    useSelector((state) => state?.userTripSlab?.userTripSlab?.data?.body) || [];
  const timeSlabData = useSelector(
    (state) => state?.userTripSlab?.userTripSlab?.data
  );
  const rentalSlabData =
    (rentalSlabLocation?.length > 0 && rentalSlabLocation) ||
    (rentalSlabCurrentLocation?.length > 0 && rentalSlabCurrentLocation) ||
    [];

  const airportOptionData =
    rentalSlabData?.length > 0 &&
    rentalSlabData
      ?.map((item) => {
        if (item?.terminal && item.name) {
          return {
            id: item?.id,
            name: item?.terminal + " " + item?.name,
            label: item?.terminal + " " + item?.name,
            place_id: item?.placeId,
          };
        } else {
          return null;
        }
      })
      .filter(Boolean);
  const optionData =
    rentalSlabData?.length > 0 &&
    rentalSlabData
      ?.map((item) => {
        if (item?.maxTime && item?.maxDistance) {
          return {
            id: item?.id,
            name: item?.maxTime + " hr " + item?.maxDistance + " km",
            label: item?.maxTime + " hr " + item?.maxDistance + " km",
          };
        } else {
          return null;
        }
      })
      .filter(Boolean);
  const rideData = useSelector(
    (state) => state?.userTrip?.userTrip?.data?.rides
  );
  const dashboardRideData = rideData
    ?.filter((e) => e?.status === "Completed" || e?.status === "Cancelled")
    .slice(0, 2);
  const payload = {
    type: "",
    status: "",
    dateFrom: "",
    dateTo: "",
    page: "",
    pageSize: "",
    search: "",
  };
  const onChangeDate = (e, name) => {
    if (name === "date" && !isNaN(e?.$D)) {
      setDate(e?.$d?.toISOString());
      sessionStorage.setItem("date", e?.$d?.toISOString());
    }
    if (name === "endDate" && !isNaN(e?.$D)) {
      setEndDate(e?.$d?.toISOString());
      sessionStorage.setItem("endDate", e?.$d?.toISOString());
    }
  };
  useEffect(() => {
    if (token) {
      dispatch(getTrip(payload));
    }
  }, []);

  useEffect(() => {
    if (currentLocationData?.length > 0) {
      setCurrentLoader(false);
      if (value == tripEnumObject?.rental || value == tripEnumObject?.airport) {
        const rentalDataVal = {
          sourceAddress: currentLocationData[0]?.formatted_address || "",
          type: value,
        };
        if (rentalDataVal?.sourceAddress) {
          dispatch(getRentalSlab(rentalDataVal));
        }
      }
      sessionStorage.setItem("pickup", JSON.stringify(currentLocationData[0]));
      setDefaultValues({ ...defaultValues, pickup: currentLocationData[0] });
    }
  }, [currentLocationData]);

  useEffect(() => {
    const inputData = {
      type: "pickup",
      place_id: pickup?.place_id,
    };
    if (inputData?.place_id !== undefined) dispatch(getPlaceDetails(inputData));
  }, [pickup]);

  useEffect(() => {
    const payload = {
      type: value,
      sourceAddress:
        pickupLoc?.formatted_address ||
        pickupLoc?.description ||
        defaultValues.pickupLoc?.formatted_address ||
        defaultValues.pickupLoc?.description ||
        "",
    };
    if (value === tripEnumObject?.oneWay || payload.sourceAddress) {
      dispatch(getTripSlab(payload));
    }
  }, [value, pickupLoc]);

  const onInputChangeVal = debounce((event, input, name) => {
    if (
      (input !== " " && name === "pickup") ||
      value === tripEnumObject?.outStationRound
    ) {
      const data = {
        name: input,
        sessiontoken: "",
        location: currentLat ? currentLat + "," + currentLong : "",
      };
      dispatch(getAutoComplete(data));
    } else if (name === "drop" && value === tripEnumObject?.oneWay) {
      if (input !== "") {
        const data = {
          name: input,
          location: placeDetailsData || currentLat || "",
        };
        dispatch(getNearBySearch(data));
      }
    }
  }, 500);

  const handleChange = () => {
    navigate("/myride");
  };

  const onCurrentAddress = debounce(() => {
    setCurrentLoader(true);
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setCurrentLat(position?.coords?.latitude);
        setCurrentLong(position?.coords?.longitude);
        const data = {
          latlng: position?.coords?.latitude
            ? position?.coords?.latitude + "," + position?.coords?.longitude
            : " ",
        };
        dispatch(getGeocode(data));
      },
      function (errors) {
        toast.info("Please enable location permission and try again", {
          autoClose: toastObject?.infoAutoClose,
        });
        setCurrentLoader(false);
      }
    );
  }, 500);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    localStorage.removeItem("type");
    setSearchParams({ type: newValue });
    setNeedPlacard(false);
    setPlacardText('');
    sessionStorage.removeItem("needPlacard");
    sessionStorage.removeItem("placardText");
  };

  const handleInput = (e, value) => {
    setRentalPackage(e.target.value);
  };

  const onSubmitBtn = (data, code) => {
    navigate("/ride?type=" + value, { state: { type: value } });
  };

  const onHandleChange = (event, data, name) => {
    if (
      name === "pickup" &&
      (value == tripEnumObject?.rental || value == tripEnumObject?.airport)
    ) {
      const rentalDataVal = {
        sourceAddress:
          data?.formatted_address || data?.description || data?.name,
        type: value,
      };
      dispatch(getRentalSlab(rentalDataVal));
    }
    if (name === "pickup") {
      setPickup(data);
    }
  };
  const formData = (value) => {
    switch (value) {
      case tripEnumObject?.rental:
        return rentalData(optionData?.length > 0 ? optionData : []);
      case tripEnumObject?.airport:
        return airportData(
          airportOptionData?.length > 0 ? airportOptionData : []
        );
      case tripEnumObject?.outStationRound:
        return outStationData();
      default:
        return oneWayData();
    }
  };

  const [travellerData, setTravellerData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    countryCode: "+91",
    email: "",
  });

  const [bookingData, setBookingData] = useState(null);

  const handleTravellerSubmit = (data) => {
    setTravellerData(data);
    sessionStorage.setItem("userDetails", JSON.stringify(data)); // ✅ persist traveller details
  };

  const handleBookingSubmit = (data) => setBookingData(data);

  const handleFinalSubmit = () => {
    if (
      !travellerData.email ||
      !travellerData.name ||
      !travellerData.phoneNumber
    ) {
      toast.error("Please fill in all traveller details");
      return;
    }
    if (!bookingData) {
      toast.error("Please complete the booking details");
      return;
    }
    const finalData = { traveller: travellerData, booking: bookingData };
    console.log("Final Submission:", finalData);
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={2}
       sx={{
          px: { xs: 0, sm: 8 }, // 0 padding on mobile, 8 on tablet/desktop
        }}
    >
      <Grid xs={12}>
        <UserDetails
          onSubmit={handleTravellerSubmit}
          initialData={travellerData}
        />
      </Grid>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        className="dashboardBg"
      >
        <Grid item className="ml60mb20" sm={12}>
          <CommonRideTab
            formData={formData(value)}
            optionData={optionData?.length > 0 ? optionData : []}
            airportOptionData={
              airportOptionData?.length > 0 ? airportOptionData : []
            }
            onInputChangeVal={onInputChangeVal}
            locationData={locationData}
            nearbySearchData={nearbySearchData}
            timeSlabData={timeSlabData}
            currentLocationData={currentLocationData}
            onCurrentAddress={onCurrentAddress}
            currentLat={currentLat}
            currentLong={currentLong}
            defaultTripValues={defaultValues}
            onSubmitBtn={onSubmitBtn}
            value={value}
            handleTabChange={handleTabChange}
            onChangeDate={onChangeDate}
            currentLoader={currentLoader}
            handleInput={handleInput}
            onHandleChange={onHandleChange}
            rentalPackage={rentalPackage}
            bufferTime={bufferTime}
            pageType={props?.pageType || "commonRideTab"}
            needPlacard={needPlacard}
            setNeedPlacard={setNeedPlacard}
            placardText={placardText}
            setPlacardText={setPlacardText}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CommonRideView;
